let Variable = new Object()
// Variable.pageData = {
//     total:0,
//     pageno:1, // 当前页
//     pagesize:10, // 当前条数
//     pagesizeList:[10,20,30,40,50,60,70,80,90,100]
// }
Variable.pageData = function () {
    return {
        total:0,
        pageno:1, // 当前页
        pagesize:10, // 当前条数
        pagesizeList:[10,20,30,40,50,60,70,80,90,100]
    }
}
Variable.detailPageData = function () {
    return {
        total:0,
        pageno:1, // 当前页
        pagesize:5, // 当前条数
        pagesizeList:[5,10,20,30,40]
    }
}
Variable.middlePageData = function () {
    return {
        total:0,
        pageno:1, // 当前页
        pagesize:8, // 当前条数
        pagesizeList:[8,10,20,30,40]
    }
}
// 输入的最大长度
Variable.inputMax = 50

// 租户号
Variable.enterpriseNum = '000000'
// 应用标识
Variable.identify = 'portal'

export default Variable